import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import {
  BodyWrapper,
  Header,
  Loader,
  MainWrapper,
  WelcomeElement,
} from '@components';
import { businessQuery, sitesQuery } from '@queries';

import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';

import { Template } from './Template/Template.jsx';

import './Templates.scss';

export const Templates = () => {
  const { t, i18n } = useTranslation();
  const { businessID } = useParams();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // Fetch template sites
  const { data: templatesData, isPending: templatesIsPending } = useQuery(
    sitesQuery({
      deleted: 0,
      limit: 20,
      order_by: 'title',
      type: 'template',
      _fields: ['id', 'title', 'theme_id', 'screenshot_thumbnail'].join(','),
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <span>{t('Templates')}</span>
            </li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Templates')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/projects/${businessID}/templates/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>
            {(templatesIsPending || businessIsPending) && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {!templatesIsPending && !businessIsPending && (
              <>
                {templatesData.objects.length == 0 && (
                  <WelcomeElement>
                    <h1>Templates</h1>
                    <p>
                      Website templates are the shared design and pages that can
                      be assigned and reused across multiple websites in your
                      project.
                    </p>
                    <Link
                      to={`/dashboard/projects/${businessID}/templates/new`}
                      className="sb-btn sb-btn-save"
                    >
                      Add a template
                    </Link>
                  </WelcomeElement>
                )}
                {templatesData.objects.length > 0 && (
                  <div className="sb-grid sb-websites-wrap">
                    {templatesData.objects.map((template) => (
                      <Template
                        key={template.id}
                        businessData={businessData}
                        templateData={template}
                      />
                    ))}
                    {/* below elements needed to fill the grid */}
                    <div className="sb-template-item"></div>
                    <div className="sb-template-item"></div>
                    <div className="sb-template-item"></div>
                  </div>
                )}
              </>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
